import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/home-storage-services.jpg'),
    alt: 'home storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'home storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Home</span><span>Storage Services</span>',
  description:
    "Whether you're decluttering, moving, or just need extra space, our home storage services offer secure, flexible, and affordable solutions to store your belongings.",
  image: {
    url: '/images/v2/pages/landing-pages/home-storage-services/hero-image.jpg',
    alt: 'Affordable Home Storage Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Your Perfect Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Home Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/home-storage-services/how-our-home-storage-services-work.png',
    alt: 'How Our Home Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description:
        'Choose from a range of storage unit sizes, perfect for anything from a few boxes to entire rooms of furniture.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 2,
      title: 'Easy Scheduling',
      description:
        'Simply schedule a convenient pickup time online, and our team will collect your items for secure storage.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/easy-scheduling.png',
        alt: 'Easy Scheduling'
      }
    },
    {
      id: 3,
      title: 'Secure Storage Facilities',
      description: 'All items are stored in secure, monitored facilities to ensure the safety of your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/secure-storage-facilities.png',
        alt: 'Secure Storage Facilities'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Home Storage Solutions',
  description:
    'Our home storage services designed to help you reclaim your space. Our services offer safe and flexible options for both short- and long-term needs, ensuring your belongings are securely stored while you enjoy a clutter-free environment. Enjoy peace of mind with our reliable storage solutions today!',
  image: {
    src: '/images/v2/pages/landing-pages/home-storage-services/affordable-home-storage-solutions.jpg',
    alt: 'Affordable Home Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Our Home Storage Services',

  cards: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description:
        'Our home storage solutions come with transparent, budget-friendly pricing, making it easier to store your items without breaking the bank.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/affordable-pricing.png',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 2,
      title: 'Convenient Pickup and Delivery',
      description: 'We offer flexible pickup and delivery options, so your items are stored with ease and convenience.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/convenient-pickup-and-delivery.png',
        alt: 'Convenient Pickup and Delivery'
      }
    },
    {
      id: 3,
      title: 'Security and Protection',
      description:
        'Our state-of-the-art storage facilities are equipped with 24/7 surveillance and security, ensuring the safety of your belongings at all times.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/security-and-protection.png',
        alt: 'Security and Protection'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Home Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description:
            'Reclaim space in your home by storing furniture, seasonal items, or keepsakes until you need them.'
        },
        {
          id: 2,
          title: 'Renters',
          description:
            'Store personal belongings when moving between homes, renovating, or simply decluttering your living space.'
        },
        {
          id: 3,
          title: 'Students',
          description: 'Store your items during the summer break or while moving out of a dorm or apartment.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/who-should-use-home-storage-services.jpg',
        alt: 'Who Should Use Home Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Flexible Storage Solutions for Homeowners',

  cards: [
    {
      id: 1,
      title: 'Decluttering Storage Solution',
      description: 'Store excess furniture, seasonal décor, and personal items to create more room in your home.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/decluttering-storage-solution.png',
        alt: 'Decluttering Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore More' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Store your items in between homes, making the moving process smoother and more organized.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore More' }
    },
    {
      id: 3,
      title: 'Renovation Storage Solution',
      description:
        'Need a temporary space for your belongings while renovating? We offer safe, convenient storage solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/home-storage-services/renovation-storage-solution.png',
        alt: 'Renovation Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore More' }
    },
    {
      id: 4,
      title: 'Seasonal Storage Solution',
      description:
        'Store seasonal items like holiday decorations, winter gear, or summer furniture until they’re needed again.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Seasonal Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Home Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/home-storage-services/why-choose-shipandstorage-for-home-storage-services.jpg',
    alt: 'Why Choose ShipAndStorage for Home Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable and Transparent Pricing',
      description:
        'With our clear and competitive pricing, you won’t find any hidden fees. Our storage solutions fit within your budget.'
    },
    {
      id: 2,
      title: '24/7 Secure Access',
      description:
        'Our facilities are monitored around the clock, giving you peace of mind that your items are always safe.'
    },
    {
      id: 3,
      title: 'Flexible Storage Options',
      description: 'We offer a range of storage unit sizes, so you can find the perfect fit for your belongings.'
    },
    {
      id: 4,
      title: 'No Long-Term Commitments',
      description: 'We offer flexible rental terms, so you can store your items for as long or as short as you need.'
    },
    {
      id: 5,
      title: 'Convenient Pickup and Delivery',
      description:
        'Our team will come to your home, pick up your items, and transport them securely to our storage facility.'
    },
    {
      id: 6,
      title: 'Customer-Focused Service',
      description:
        'Our team is committed to providing a smooth and hassle-free storage experience from start to finish.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Affordable and Secure Home Storage Services Available',
  description:
    'Affordable home storage services available. Secure and convenient solutions for storing your personal belongings safely and easily.',
  image: {
    src: '/images/v2/pages/landing-pages/home-storage-services/affordable-and-secure-home-storage-services-available.png',
    alt: 'Affordable and Secure Home Storage Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage collaborates with top logistics providers to ensure that your home storage experience is secure, efficient, and reliable.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers reliable shipping and storage solutions to help you securely store and transport your items.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides global shipping and storage solutions, ensuring your home storage needs are met efficiently.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers secure storage options with excellent logistics, helping you store and ship your items with ease.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
